import { useState, useEffect, useCallback, useRef } from "react";
import PropTypes from "prop-types";
import api from "api/api";
//Material UI Components
import Button from "@mui/material/Button";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";

import IconButton from "@mui/material/IconButton";
import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";
import CancelIcon from "@mui/icons-material/Cancel";

import Loader from "../common/Loader";
import ActionStandardForm from "./ActionStandardForm";
import ActionStandardKPI from "./ActionStandardKPI";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import { useSelector, useDispatch } from "react-redux";
import { showNotification } from "store/features/notificationSlice";
import FragranceActionStandardForm from "./FragranceActionStandardForm";
import FragranceActionStandardKPI from "./fragranceTesting/ActionStandardKPI";

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            style={{
                padding: 0,
            }}
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <>{children}</>}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const newFormData = {
    action_standard_groups: {},
    action_standard_kpis: [],
};

// const ActionStandardTabs = ({ coreDataId, closeActionStandardModal, studyTypeMethod, weighted = false, coreData = {}, viewOnly = false, setIsASUpdateLoading = () => {}, setIsASPostLoading = () => {} }) => {
const ActionStandardTabs = ({ coreDataId, closeActionStandardModal, studyTypeMethod, weighted = false, coreData = {}, viewOnly = false }) => {
    const productCategoryData = useSelector((state) => state.settingsStore.productCategory);
    const productCategoryId = productCategoryData?.value || null;
    const isHairCare = process.env?.REACT_APP_HAIR_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isSkinCare = process.env?.REACT_APP_SKIN_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isBeautyAndWellbeing = isHairCare || isSkinCare;
    const dispatch = useDispatch();
    const formRef = useRef();
    const kpiRef = useRef();
    const [isKpiOoDataMappingDataLoading, setIsKpiOoDataMappingDataLoading] = useState(false);
    const [kpiOptions, setKpiOptions] = useState([]);

    const [productSecondaryData, setProductSecondaryData] = useState([]);
    const [competitorProducts, setCompetitorProducts] = useState([]);
    const [unileverProducts, setUnileverProducts] = useState([]);

    const [sampleInformation, setSampleInformation] = useState(0);
    const [formData, setFormData] = useState([newFormData]);

    const [activeTab, setActiveTab] = useState(0);

    const [maxAllowedTabs, setMaxAllowedTabs] = useState(1);
    const [err, setErr] = useState([]);

    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [idToDelete, setIdToDelete] = useState(null);
    const [deleteTabEvent, setDeleteTabEvent] = useState(null);

    const [isASPostLoading, setIsASPostLoading] = useState(false);
    const [isASUpdateLoading, setIsASUpdateLoading] = useState(false);
    const [asSubmitted, setAsSubmitted] = useState(false);

    const [isAddTabDisabled, setIsAddTabDisabled] = useState(false);

    const studyType = coreData?.study_type__title || null;
    const isHomeUseTest = (coreData?.study_type_method__default_title || "").toLowerCase() === "home use test";
    const transformBwKpis = (kpis) => {
        return kpis.map((kpiObj) => ({
            ...kpiObj,
            kpi: (kpiObj.kpi || []).filter(Boolean).map((bv) => ({
                backend_variable: bv,
                opretor: kpiObj.is_if ? "" : "AND",
                test_name: "student's t test comparisons",
                test_title: "Student's T Test Comparisons",
            })),
        }));
    };

    const [likertScaleData, setLikertScaleData] = useState({});

    const fetchLikertScaleData = useCallback(() => {
        if (studyTypeMethod) {
            try {
                let url = `${process.env.REACT_APP_SERVER_PATH}/data-mappings/likert-scale/?product_category=${productCategoryId}&study_type_method=${studyTypeMethod}`;
                api.get(url)
                    .then((response) => {
                        setLikertScaleData(response.data);
                    })
                    .catch((error) => {
                        handleError("error", error);
                    });
            } catch (error) {
                handleError("error", error);
            }
        }
    }, [productCategoryId, studyTypeMethod]);

    useEffect(() => {
        if (productCategoryId) {
            fetchLikertScaleData();
        }
    }, [productCategoryId, fetchLikertScaleData]);

    const getVariableCategory = () => {
        const studyTypeMethod = coreData?.study_type_method__title || null;
        if (studyTypeMethod === "ICT") {
            return "Fragrance Metrics Analysis,Preference Analysis";
        } else if (studyTypeMethod === "CLT") {
            return "Fragrance Metrics Analysis,JAR,Agreement KPI";
        } else if (studyTypeMethod === "Express CLT") {
            return "Fragrance Metrics Analysis,Product Preference Analysis";
        } else if (studyTypeMethod === "Home Use Test") {
            return "KPI (OO)";
        } else {
            return isBeautyAndWellbeing ? "KPI (OO),Agreement KPI,JAR" : "KPI (OO)";
        }
    };

    const getAsKpiData = (tabId, valueObj) => {
        const data = JSON.parse(JSON.stringify(formData?.[tabId])) || {};
        let asKpi = data?.action_standard_kpis || [];

        let ifData = asKpi.filter((ele) => ele.is_if === true)?.[0] || {};
        let elseIfData = asKpi.filter((ele) => ele.is_if === false)?.[0] || {};

        let _temp = [];

        const flag = valueObj?.is_if;
        if (flag) {
            ifData = { ...valueObj };
        } else {
            elseIfData = { ...valueObj };
        }

        if (Object.keys(ifData).length && Object.keys(elseIfData).length) {
            _temp = [ifData, elseIfData];
        } else {
            _temp = [ifData];
        }

        asKpi = _temp;

        data["action_standard_kpis"] = [...asKpi];
        const finalData = formData.map((ele, i) => (i !== tabId ? ele : data));
        setFormData([...finalData]);
        validateForms(finalData);
    };

    const removeKpiCondition = (tab, is_Add, valueObj) => {
        let data = JSON.parse(JSON.stringify(formData[tab])) || {};
        let remainingData = [];
        if (data.action_standard_kpis.length > 0) {
            remainingData = data.action_standard_kpis.filter((ele) => ele.is_if);
        }
        if (is_Add) {
            remainingData.push(valueObj);
        }
        data["action_standard_kpis"] = remainingData;

        const finalData = formData.map((ele, i) => (i !== tab ? ele : data));
        setFormData([...finalData]);
        validateForms(finalData);
    };

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    const transformData = () => {
        const obj = JSON.parse(JSON.stringify(formData));
        const filteredData = obj.filter((_, index) => index !== activeTab);
        const result = {};

        filteredData.forEach((item) => {
            const group = item.action_standard_groups;

            const ulCode = group?.ul_product_code;
            const compCodes = group?.comp_product_code?.split(",") || [];

            // skip if ul_product_code is missing
            if (!ulCode) return;

            if (!result[ulCode]) {
                result[ulCode] = [];
            }

            result[ulCode].push(...compCodes);
        });

        // remove duplicates
        Object.keys(result).forEach((key) => {
            result[key] = [...new Set(result[key])];
        });

        return result;
    };

    const updateOptions = () => {
        let _tempCP = [];
        let _tempUP = [];
        productSecondaryData.map((datum) => {
            if (datum.isCompetitorProduct) {
                _tempCP.push({ value: datum.title, label: datum.title });
            } else {
                _tempUP.push({ value: datum.title, label: datum.title });
            }
        });
        const competitorOptions = _tempCP.length > 0 ? _tempCP : _tempUP;
        const unileverOptions = _tempUP.length > 0 ? _tempUP : _tempCP;

        const optionsMap = transformData();
        const excludeUlps = [];
        Object.entries(optionsMap).forEach(([key, values]) => {
            const areAllPresent = competitorOptions.filter((item) => item.value !== key).every((item) => values?.includes(item.value));
            if (areAllPresent) {
                excludeUlps.push(key);
            } else {
                excludeUlps?.includes(key) && excludeUlps.splice(excludeUlps.indexOf(key), 1);
            }
        });
        const filteredUlpOptions = unileverOptions?.filter((ulp) => !excludeUlps?.includes(ulp.value)) || [];

        return filteredUlpOptions;
    };

    const updateMaxAllowedTabs = () => {
        const obj = JSON.parse(JSON.stringify(formData));
        const result = {};

        obj.forEach((item) => {
            const group = item.action_standard_groups;

            const ulCode = group?.ul_product_code;
            const compCodes = group?.comp_product_code || "";

            // skip if ul_product_code is missing
            if (!ulCode) return;

            if (!result[ulCode]) {
                const cmpArray = compCodes.split(",")
                result[ulCode] = [...cmpArray];
            } else {
                const cmpArray = compCodes.split(",")
                result[ulCode].push(...cmpArray);
            }
        });

        // optional: remove duplicates based on value
        Object.keys(result).forEach((key) => {
            const unique = [];
            const seen = new Set();

            result[key].forEach((item) => {
                if (!seen.has(item)) {
                    seen.add(item);
                    unique.push(item);
                }
            });

            result[key] = unique;
        });

        let _tempCP = [];
        let _tempUP = [];
        productSecondaryData.map((datum) => {
            if (datum.isCompetitorProduct) {
                _tempCP.push({ value: datum.title, label: datum.title });
            } else {
                _tempUP.push({ value: datum.title, label: datum.title });
            }
        });
        const competitorOptions = _tempCP.length > 0 ? _tempCP : _tempUP;
        const unileverOptions = _tempUP.length > 0 ? _tempUP : _tempCP;

        const isTabAllowed = unileverOptions.every((option) => {
            if (!result[option.value]) return false;

            const mappedValues = result[option.value];

            return competitorOptions.every((datum) => mappedValues?.includes(datum.value));
        });

        return isTabAllowed;
    };

    const getAsFormData = (tabId, value, key) => {
        const data = JSON.parse(JSON.stringify(formData?.[tabId])) || {};

        const asForm = data?.action_standard_groups || {};

        if (key === "comp_product_code" || key === "ul_product_code") {
            const previousSel = data?.action_standard_groups["comp_product_code"] || data?.action_standard_groups["ul_product_code"] || null;
            let currentSel = value || null;

            if (Array.isArray(currentSel)) {
                currentSel = currentSel.map((v) => v.value).join(",");
            }

            if (currentSel && previousSel) {
                let flag = false;
                if (previousSel === currentSel) {
                    flag = true;
                    if (key === "comp_product_code") {
                        handleError("error", "Product already selected in Unilever product.");
                    } else {
                        handleError("error", "Product already selected in Benchmark product.");
                    }
                } else {
                    formData.forEach((datum) => {
                        if ((datum.action_standard_groups.comp_product_code === previousSel || datum.action_standard_groups.comp_product_code === currentSel) && (datum.action_standard_groups.ul_product_code === previousSel || datum.action_standard_groups.ul_product_code === currentSel)) {
                            flag = true;
                            handleError("error", "Selected Group already exists.");
                        }
                    });
                }
                if (!flag) {
                    asForm[key] = currentSel;
                    if (key === "comp_product_code") {
                        const dataMap = Object.fromEntries(productSecondaryData.map((d) => [d.title, d.sampleSize]));
                        const valuesArray = Array.isArray(value) ? value.map((v) => v.value) : [value];
                        asForm["comp_product_sample_size"] = valuesArray.map((v) => dataMap[v] || 0).join(", ");
                        asForm["ul_product_sample_size"] = productSecondaryData.filter((datum) => datum.title === asForm["ul_product_code"])[0]?.sampleSize || 0;
                        asForm["consumer_filter"] = {};
                    } else if (key === "ul_product_code") {
                        asForm["ul_product_sample_size"] = productSecondaryData.filter((datum) => datum.title === currentSel)[0]?.sampleSize || 0;
                        asForm["comp_product_sample_size"] = productSecondaryData.filter((datum) => datum.title === asForm["comp_product_code"])[0]?.sampleSize || 0;
                        asForm["consumer_filter"] = {};
                    }
                }
            } else {
                asForm[key] = currentSel;
                if (key === "comp_product_code") {
                    const dataMap = Object.fromEntries(productSecondaryData.map((d) => [d.title, d.sampleSize]));
                    const valuesArray = Array.isArray(value) ? value.map((v) => v.value) : [value];
                    asForm["comp_product_sample_size"] = valuesArray.map((v) => dataMap[v] || 0).join(", ");
                    asForm["ul_product_sample_size"] = productSecondaryData.filter((datum) => datum.title === asForm["ul_product_code"])[0]?.sampleSize || 0;
                    asForm["consumer_filter"] = {};
                } else if (key === "ul_product_code") {
                    asForm["ul_product_sample_size"] = productSecondaryData.filter((datum) => datum.title === currentSel)[0]?.sampleSize || 0;
                    asForm["comp_product_sample_size"] = productSecondaryData.filter((datum) => datum.title === asForm["comp_product_code"])[0]?.sampleSize || 0;
                    asForm["consumer_filter"] = {};
                }
            }
        } else {
            asForm[key] = value;
        }

        asForm["core_data_model_id"] = coreDataId;
        asForm["sample_size"] = sampleInformation;

        if (key == "consumer_filter") {
            const keys = Object.keys(value);
            if (keys.length !== 0) {
                asForm["weight"] = false;
            } else {
                asForm["weight"] = weighted;
            }
        }

        data["action_standard_groups"] = { ...asForm };
        const finalData = formData.map((ele, i) => (i !== tabId ? ele : data));
        setFormData([...finalData]);
        validateForms(finalData);
    };

    const getFragranceAsFormData = (tabId, value, key) => {
        const data = JSON.parse(JSON.stringify(formData?.[tabId])) || {};
        const asForm = data?.action_standard_groups || {};
        let _tempCP = [];
        let _tempUP = [];
        productSecondaryData.map((datum) => {
            if (datum.isCompetitorProduct) {
                _tempCP.push({ value: datum.title, label: datum.title });
            } else {
                _tempUP.push({ value: datum.title, label: datum.title });
            }
        });
        const competitorOptions = _tempCP.length > 0 ? _tempCP : _tempUP;
        const unileverOptions = _tempUP.length > 0 ? _tempUP : _tempCP;

        if (key === "comp_product_code" || key === "ul_product_code") {
            asForm[key] = value;
            if (key === "comp_product_code") {
                const valuesArray = value.map((v) => v.value);
                const previousSel = data?.action_standard_groups["comp_product_code"] || null;
                const currentSel = valuesArray.join(",");
                if (currentSel && previousSel) {
                    let flag = false;
                    if (previousSel === currentSel) {
                        flag = true;
                        handleError("error", "Product already selected in Unilever product.");
                    } else {
                        formData.forEach((datum) => {
                            if (datum.action_standard_groups.comp_product_code === currentSel && datum.action_standard_groups.ul_product_code === asForm["ul_product_code"]) {
                                flag = true;
                                handleError("error", "Selected Group already exists.");
                            }
                        });
                    }
                    if (flag) return;
                }
                const filteredUnileverProducts = unileverOptions.filter((item) => !valuesArray?.includes(item.value));
                asForm["unileverProducts"] = filteredUnileverProducts;
                const dataMap = Object.fromEntries(productSecondaryData.map((d) => [d.title, d.sampleSize]));
                asForm["comp_product_sample_size"] = isBeautyAndWellbeing ? valuesArray.map((v) => dataMap[v] || 0).join(", ") : value.reduce((sum, selected) => sum + (dataMap[selected.value] || 0), 0);
                asForm["ul_product_sample_size"] = productSecondaryData.filter((datum) => datum.title === asForm["ul_product_code"])[0]?.sampleSize || 0;
                asForm["consumer_filter"] = {};
                asForm["comp_product_code"] = valuesArray.join(",");
            } else if (key === "ul_product_code") {
                const filteredCompetitorProducts = competitorOptions.filter((item) => item.value !== value);
                const optionsMap = transformData();
                const isPresent = Object.keys(optionsMap)?.includes(value);
                const finalCompetitorProducts = isPresent ? filteredCompetitorProducts.filter((item) => !optionsMap[value]?.includes(item.value)) : filteredCompetitorProducts;
                asForm["competitorProducts"] = finalCompetitorProducts;
                asForm["ul_product_sample_size"] = productSecondaryData.filter((datum) => datum.title === value)[0]?.sampleSize || 0;
                asForm["comp_product_sample_size"] = productSecondaryData.filter((datum) => datum.title === asForm["comp_product_code"])[0]?.sampleSize || 0;
                asForm["consumer_filter"] = {};
            }
        } else {
            asForm[key] = value;
        }

        asForm["core_data_model_id"] = coreDataId;
        asForm["sample_size"] = sampleInformation;

        if (key == "consumer_filter") {
            const keys = Object.keys(value);
            if (keys.length !== 0) {
                asForm["weight"] = false;
            } else {
                asForm["weight"] = weighted;
            }
        }

        data["action_standard_groups"] = { ...asForm };
        const finalData = formData.map((ele, i) => (i !== tabId ? ele : data));
        setFormData([...finalData]);
        validateForms(finalData);
    };

    const getAsCfData = (tabId, data, ulp, cmp) => {
        if (studyType === "Fragrance Testing" && !isHomeUseTest) {
            fetchFragranceSecondaryData(true, data, ulp, cmp, formData?.[tabId], formData, tabId);
        } else {
            fetchSecondaryData(true, data, ulp, cmp, formData?.[tabId], formData, tabId);
        }
    };

    const fetchSecondaryData = useCallback(
        (cfFlag = false, cf = {}, ulp, cmp, acfData, _formData, tabId) => {
            const payload = {
                core_data_id: coreDataId,
                variable_category: "KPI (OO)",
                study_type_method: studyTypeMethod,
            };
            if (cfFlag && ulp && cmp) {
                const datum = {};
                Object.keys(cf).forEach((key) => {
                    datum[key] = cf[key].join(",");
                });
                const cmpStr = Array.isArray(cmp) ? cmp.map((c) => c.value ?? c).join(",") : cmp;
                (payload["product_code"] = ulp + "," + cmpStr), (payload["consumer_filter"] = datum);
            }
            if (productCategoryId) {
                payload[`product_category`] = productCategoryId;
            }
            try {
                setIsKpiOoDataMappingDataLoading(true);
                api.post(process.env.REACT_APP_SERVER_PATH + `/secondary-study-datas/grouped/`, payload)
                    .then((res) => {
                        if (cf && ulp && cmp) {
                            let obj = JSON.parse(JSON.stringify(acfData)) || {};
                            const asForm = obj?.action_standard_groups || {};

                            const cmpTitles = Array.isArray(cmp) ? cmp.map((c) => c.value ?? c) : [cmp];
                            const cmpFiltered = res?.data.filter((ele) => cmpTitles?.includes(ele.title));
                            const _obj = {
                                ul_product_sample_size: res?.data.filter((ele) => ele.title === ulp)?.[0]?.sampleSize,
                                comp_product_sample_size: isBeautyAndWellbeing ? cmpTitles.map((t) => cmpFiltered.find((e) => e.title === t)?.sampleSize || []).join(", ") : res?.data.filter((ele) => ele.title === cmp)?.[0]?.sampleSize,
                                consumer_filter: cf,
                                weight: Object.keys(cf).length !== 0 ? false : asForm.weight,
                            };
                            const formD = {
                                ...asForm,
                                ..._obj,
                            };

                            obj = {
                                action_standard_groups: { ...formD },
                                action_standard_kpis: [...obj.action_standard_kpis],
                            };
                            const finalData = _formData.map((ele, i) => (i !== tabId ? ele : obj));

                            setFormData([...finalData]);
                        } else {
                            setProductSecondaryData(res?.data || []);
                        }
                        setIsKpiOoDataMappingDataLoading(false);
                    })
                    .catch((error) => {
                        handleError("error", error);
                        setIsKpiOoDataMappingDataLoading(false);
                    });
            } catch (error) {
                handleError("error", error);
                setIsKpiOoDataMappingDataLoading(false);
            }
        },
        [coreDataId, productCategoryId]
    );

    const fetchFragranceSecondaryData = useCallback(
        (cfFlag = false, cf = {}, ulp, cmp, acfData, _formData, tabId) => {
            const payload = {
                core_data_id: coreDataId,
                variable_category: "Fragrance Metrics Analysis",
                study_type_method: studyTypeMethod,
            };
            if (cfFlag && ulp && cmp.length > 0) {
                const datum = {};
                Object.keys(cf).forEach((key) => {
                    datum[key] = cf[key].join(",");
                });
                (payload["product_code"] = ulp + "," + cmp.map((c) => c.value).join(",")), (payload["consumer_filter"] = datum);
            }
            if (productCategoryId) {
                payload[`product_category`] = productCategoryId;
            }
            try {
                setIsKpiOoDataMappingDataLoading(true);
                api.post(process.env.REACT_APP_SERVER_PATH + `/secondary-study-datas/grouped/`, payload)
                    .then((res) => {
                        if (cf && ulp && cmp.length > 0) {
                            let obj = JSON.parse(JSON.stringify(acfData)) || {};
                            const asForm = obj?.action_standard_groups || {};
                            const cmpArray = cmp.map((c) => c.value);
                            const cmpSampleSize = res?.data.filter((ele) => cmpArray?.includes(ele.title)).reduce((a, x) => a + x.sampleSize, 0);

                            const _obj = {
                                ul_product_sample_size: res?.data.filter((ele) => ele.title === ulp)?.[0]?.sampleSize,
                                comp_product_sample_size: cmpSampleSize,
                                consumer_filter: cf,
                                weight: Object.keys(cf).length !== 0 ? false : asForm.weight,
                            };
                            const formD = {
                                ...asForm,
                                ..._obj,
                            };

                            obj = {
                                action_standard_groups: { ...formD },
                                action_standard_kpis: [...obj.action_standard_kpis],
                            };
                            const finalData = _formData.map((ele, i) => (i !== tabId ? ele : obj));

                            setFormData([...finalData]);
                        } else {
                            setProductSecondaryData(res?.data || []);
                        }
                        setIsKpiOoDataMappingDataLoading(false);
                    })
                    .catch((error) => {
                        handleError("error", error);
                        setIsKpiOoDataMappingDataLoading(false);
                    });
            } catch (error) {
                handleError("error", error);
                setIsKpiOoDataMappingDataLoading(false);
            }
        },
        [coreDataId, productCategoryId]
    );

    useEffect(() => {
        if (studyType === "Fragrance Testing" && !isHomeUseTest) {
            fetchFragranceSecondaryData();
        } else {
            fetchSecondaryData();
        }
    }, [fetchSecondaryData, fetchFragranceSecondaryData, studyType, isHomeUseTest]);

    useEffect(() => {
        const isAddTabAllowed = updateMaxAllowedTabs();
        setIsAddTabDisabled(isAddTabAllowed);
    }, [formData]);

    useEffect(() => {
        async function fetchKpiOoDataMappingData() {
            try {
                const variableCategory = getVariableCategory();
                let url = process.env.REACT_APP_SERVER_PATH + `/data-mappings/study-driven-backend-variables/?core_data_model=${coreDataId}&variable_category=${encodeURIComponent(variableCategory)}`;
                if (productCategoryId) {
                    url += `&product_category=${productCategoryId}`;
                }
                if (studyTypeMethod) {
                    url += `&study_type_method=${studyTypeMethod}`;
                }
                await api
                    .get(url)
                    .then((res) => {
                        let finalKpiArr = [];
                        // const data = Object.values(res.data?.backend_variable_display_label_array).flat();
                        const data = Object.entries(res.data?.backend_variable_display_label_array).flatMap(([key, arr]) =>
                            arr.map((item) => ({
                                ...item,
                                variableCategory: key,
                            }))
                        );
                        data.forEach((datum) => {
                            const likertValue = likertScaleData?.[datum?.backend_variable];
                            const obj = {
                                value: datum.backend_variable,
                                label: (
                                    <span>
                                        {datum.display_label}
                                        {likertValue ? (
                                            <>
                                                {" ("}
                                                {likertValue}
                                                {")"}
                                            </>
                                        ) : null}

                                        {" ("}
                                        <span style={{ fontStyle: "italic", fontSize: "0.8em", color: "#666" }}>{datum?.variableCategory}</span>
                                        {")"}
                                    </span>
                                ),
                                variableCategory: datum.variableCategory,
                            };
                            finalKpiArr.push(obj);
                        });
                        setKpiOptions(finalKpiArr);
                    })
                    .catch((error) => {
                        handleError("error", error);
                    });
            } catch (error) {
                handleError("error", error);
            }
        }
        fetchKpiOoDataMappingData();
    }, [coreDataId, productCategoryId, studyTypeMethod, likertScaleData]);

    function factorial(n) {
        if (n === 0 || n === 1) return 1;
        let result = 1;
        for (let i = 2; i <= n; i++) {
            result *= i;
        }
        return result;
    }

    function generateCombinations(A, B, same = false) {
        const m = A.length;
        const n = B.length;

        if (same) {
            return factorial(n) / (factorial(2) * factorial(n - 2));
        } else {
            return m * n;
        }
    }

    useEffect(() => {
        let _tempCP = [];
        let _tempUP = [];
        let sampleSize = 0;
        productSecondaryData.map((datum) => {
            if (datum.isCompetitorProduct) {
                _tempCP.push({ value: datum.title, label: datum.title });
            } else {
                _tempUP.push({ value: datum.title, label: datum.title });
            }
            sampleSize += datum.sampleSize;
        });
        setCompetitorProducts(_tempCP.length > 0 ? _tempCP : _tempUP);
        setUnileverProducts(_tempUP.length > 0 ? _tempUP : _tempCP);
        setSampleInformation(sampleSize);
        if (studyType === "Fragrance Testing" || isBeautyAndWellbeing) {
            setFormData((prev) =>
                prev.map((item) => ({
                    ...item,
                    action_standard_groups: {
                        ...item.action_standard_groups,
                        unileverProducts: _tempUP.length > 0 ? _tempUP : _tempCP,
                        competitorProducts: _tempCP.length > 0 ? _tempCP : _tempUP,
                    },
                }))
            );
            const isSame = _tempCP.length === 0 || _tempUP.length === 0 ? true : false;
            const maxTabs = generateCombinations(unileverProducts, competitorProducts, isSame);
            setMaxAllowedTabs(maxTabs);
        } else {
            if (_tempCP.length === 0 || _tempUP.length === 0) {
                if (_tempUP.length === 0) {
                    setMaxAllowedTabs(sumNumbers(_tempCP.length - 1));
                } else {
                    setMaxAllowedTabs(sumNumbers(_tempUP.length - 1));
                }
            } else {
                setMaxAllowedTabs(_tempCP.length * _tempUP.length);
            }
        }
    }, [productSecondaryData]);

    function sumNumbers(n) {
        if (n <= 0) return 0;
        let sum = 0;
        for (let i = 0; i < n; i++) {
            sum += i;
        }
        return sum;
    }

    useEffect(() => {
        // set default weight
        const obj = JSON.parse(JSON.stringify(formData?.[activeTab] || {})) || {};
        const asForm = obj?.action_standard_groups || {};

        const _obj = {
            weight: Object.keys(asForm?.consumer_filter || {}).length !== 0 ? false : asForm?.weight || weighted,
        };
        const formD = {
            ...asForm,
            ..._obj,
        };
        obj["action_standard_groups"] = { ...formD };

        if (studyType === "Fragrance Testing" || isBeautyAndWellbeing) {
            const ulpOptions = asForm?.unileverProducts;
            const cmpOptions = asForm?.competitorProducts;
            const selectedUlpOptions = asForm?.ul_product_code;
            const selectedCmpOptions = asForm?.comp_product_code ? asForm?.comp_product_code.split(",") : [];
            let finalData = formData.map((ele, i) => (i !== activeTab ? ele : obj));

            const extractedUlpOptions = updateOptions();
            const filteredUlpOptions = extractedUlpOptions?.length > 0 ? extractedUlpOptions?.filter((option) => !selectedCmpOptions?.includes(option.value)) : ulpOptions?.filter((option) => !selectedCmpOptions?.includes(option.value));
            const filteredCmpOptions = cmpOptions?.filter((option) => option.value !== selectedUlpOptions);
            const updatedOptions = { unileverProducts: filteredUlpOptions?.length > 0 ? filteredUlpOptions : ulpOptions, competitorProducts: filteredCmpOptions?.length > 0 ? filteredCmpOptions : cmpOptions };
            const resData = finalData.map((ele, i) => {
                return i === activeTab ? { ...ele, action_standard_groups: { ...ele.action_standard_groups, ...updatedOptions } } : ele;
            });
            setFormData([...resData]);
        } else {
            const finalData = formData.map((ele, i) => (i !== activeTab ? ele : obj));
            setFormData([...finalData]);
        }
    }, [activeTab, weighted]);

    useEffect(() => {
        if ((!isASPostLoading && !isASUpdateLoading) && asSubmitted) {
            closeActionStandardModal("success");
            setAsSubmitted(false);
        }
    }, [isASPostLoading, isASUpdateLoading, asSubmitted]);

    const handleError = (type, error) => {
        dispatch(showNotification({ severity: type, data: error }));
    };

    const handleSubmit = async () => {
        const isValid = validateForms(formData);
        if (isValid) {
            setIsASPostLoading(true);
            setIsASUpdateLoading(true);
            handlePost();
            handleUpdate();
        } else {
            handleError("error", "Validation Failed.");
        }
    };

    const handlePost = async () => {
        try {
            const filteredData = formData
                .map((datum) => {
                    if (!Object.keys(datum.action_standard_groups).includes("id")) {
                        return datum;
                    }
                })
                .filter(Boolean)
                .filter((obj) => Object.keys(obj.action_standard_groups).length > 0 && obj.action_standard_kpis.length > 0)
                .map((obj) => {
                    const datum = {};
                    Object.keys(obj.action_standard_groups.consumer_filter).forEach((key) => {
                        datum[key] = obj.action_standard_groups.consumer_filter[key].join(",");
                    });
                    const kpis = isBeautyAndWellbeing ? transformBwKpis(obj.action_standard_kpis) : obj.action_standard_kpis;
                    return {
                        ...obj,
                        action_standard_kpis: kpis,
                        action_standard_groups: {
                            ...obj.action_standard_groups,
                            consumer_filter: datum,
                        },
                    };
                });

            const requests = filteredData?.map((datum) => {
                return api.post(process.env.REACT_APP_SERVER_PATH + `/action-standard-groups/submit/`, datum);
            });

            await api
                .all(requests)
                .then((res) => {
                    console.log("result", res);
                    // setIsASPostLoading(false);
                    // closeActionStandardModal("success");
                })
                .catch((error) => {
                    handleError("error", error);
                    setIsASPostLoading(false);
                }) 
                .finally (() => {
                    // Stops only after all APIs finish
                    setIsASPostLoading(false);
                    setAsSubmitted(true);
                    // closeActionStandardModal("success");
                });
        } catch (error) {
            handleError("error", error);
            setIsASPostLoading(false);
        }
    };

    const handleUpdate = async () => {
        try {
            const updateData = formData
                .map((datum) => {
                    if (Object.keys(datum.action_standard_groups).includes("id")) {
                        return datum;
                    }
                })
                .filter(Boolean)
                .map((obj) => {
                    const datum = {};
                    Object.keys(obj.action_standard_groups.consumer_filter).forEach((key) => {
                        datum[key] = obj.action_standard_groups.consumer_filter[key].join(",");
                    });
                    const kpis = isBeautyAndWellbeing ? transformBwKpis(obj.action_standard_kpis) : obj.action_standard_kpis;
                    return {
                        ...obj,
                        action_standard_kpis: kpis,
                        action_standard_groups: {
                            ...obj.action_standard_groups,
                            consumer_filter: datum,
                        },
                    };
                });
            const requests = updateData?.map((datum) => {
                return api.put(process.env.REACT_APP_SERVER_PATH + `/action-standard-groups/submit/${datum?.action_standard_groups?.id}/`, datum);
            });

            await api
                .all(requests)
                .then((res) => {
                    console.log("result", res);
                    // setIsASUpdateLoading(false);
                    // closeActionStandardModal("success");
                })
                .catch((error) => {
                    handleError("error", error);
                    closeActionStandardModal("error", error);
                    setIsASUpdateLoading(false);
                })
                .finally (() => {
                    // Stops only after all APIs finish
                    setIsASUpdateLoading(false);
                    setAsSubmitted(true);
                    // closeActionStandardModal("success");
                });
        } catch (error) {
            handleError("error", error);
            closeActionStandardModal("error", error);
            setIsASUpdateLoading(false);
        }
    };
    const getAsSubmittedData = useCallback(async () => {
        try {
            const url = process.env.REACT_APP_SERVER_PATH + `/action-standard-groups/submit/kpis/?archive=False&core_data_model=${coreDataId}`;
            api.get(url)
                .then((res) => {
                    if (res.data.length) {
                        const data = res.data.map((obj) => {
                            const datum = {};
                            Object.keys(obj.action_standard_groups.consumer_filter).forEach((key) => {
                                datum[key] = obj.action_standard_groups.consumer_filter[key].split(",");
                            });
                            return {
                                ...obj,
                                action_standard_groups: {
                                    ...obj.action_standard_groups,
                                    unileverProducts: unileverProducts,
                                    competitorProducts: competitorProducts,
                                    consumer_filter: datum,
                                },
                                ...((isBeautyAndWellbeing) && {
                                    action_standard_kpis: [...obj.action_standard_kpis]
                                        .sort((a, b) => (b.is_if === true ? 1 : 0) - (a.is_if === true ? 1 : 0))
                                        .map((kpiObj) => ({
                                            ...kpiObj,
                                            kpi: (kpiObj.kpi || []).map((bv) => (bv !== null && typeof bv === "object" && "backend_variable" in bv ? bv.backend_variable : bv)),
                                        })),
                                }),
                                // action_standard_kpis: obj.action_standard_kpis.map((kpiObj) => ({
                                //     ...kpiObj,
                                //     kpi: JSON.parse(kpiObj.kpi),
                                // })),
                            };
                        });
                        let _tempCP = [];
                        let _tempUP = [];
                        productSecondaryData.map((datum) => {
                            if (datum.isCompetitorProduct) {
                                _tempCP.push({ value: datum.title, label: datum.title });
                            } else {
                                _tempUP.push({ value: datum.title, label: datum.title });
                            }
                        });
                        const ulpOptions = _tempUP.length > 0 ? _tempUP : _tempCP;
                        const cmpOptions = _tempCP.length > 0 ? _tempCP : _tempUP;
                        const resData = data.map((ele, i) => {
                            const obj = JSON.parse(JSON.stringify(ele || {})) || {};
                            const asForm = obj?.action_standard_groups || {};

                            const selectedUlpOptions = asForm?.ul_product_code;
                            const selectedCmpOptions = asForm?.comp_product_code ? asForm?.comp_product_code.split(",") : [];

                            const extractedUlpOptions = updateOptions();
                            const filteredUlpOptions = extractedUlpOptions?.length > 0 ? extractedUlpOptions?.filter((option) => !selectedCmpOptions?.includes(option.value)) : ulpOptions?.filter((option) => !selectedCmpOptions?.includes(option.value));

                            const result = {};
                            const filteredData = data.filter((_, index) => index !== i);
                            filteredData.forEach((item) => {
                                const group = item.action_standard_groups;
                                const ulCode = group?.ul_product_code;
                                const compCodes = group?.comp_product_code?.split(",") || [];
                                if (!ulCode) return;

                                if (!result[ulCode]) {
                                    result[ulCode] = [];
                                }

                                result[ulCode].push(...compCodes);
                            });
                            Object.keys(result).forEach((key) => {
                                result[key] = [...new Set(result[key])];
                            });
                            const filteredCmpOptions = cmpOptions.filter((item) => !result[selectedUlpOptions]?.includes(item.value));

                            const finalUlpOptions = filteredUlpOptions?.filter((option) => !selectedCmpOptions?.includes(option.value));
                            const finalCmpOptions = filteredCmpOptions?.filter((option) => option.value !== selectedUlpOptions);
                            const updatedOptions = { unileverProducts: finalUlpOptions.length > 0 ? finalUlpOptions : ulpOptions, competitorProducts: finalCmpOptions.length > 0 ? finalCmpOptions : cmpOptions };
                            return { ...ele, action_standard_groups: { ...ele.action_standard_groups, ...updatedOptions } };
                        });
                        setFormData([...resData]);
                    }
                })
                .catch((error) => {
                    handleError("error", error);
                });
        } catch (error) {
            handleError("error", error);
        }
    }, [coreDataId, productSecondaryData]);

    useEffect(() => {
        if (!viewOnly ) {
            getAsSubmittedData();
        }
    }, [getAsSubmittedData, viewOnly]);

    // Add a new tab
    const addTab = () => {
        let prevFormDData = [...formData];
        if (studyType === "Fragrance Testing" || isBeautyAndWellbeing) {
            prevFormDData.push({
                action_standard_groups: {
                    unileverProducts: unileverProducts,
                    competitorProducts: competitorProducts,
                },
                action_standard_kpis: [],
            });
        } else {
            prevFormDData.push(newFormData);
        }
        setFormData(prevFormDData);

        setActiveTab(prevFormDData.length - 1);
    };

    // Close an existing tab
    const closeTab = () => {
        deleteTabEvent.stopPropagation();
        let items = [...formData];
        items.splice(idToDelete, 1);
        setFormData(items);
        setActiveTab(items.length - 1);
        setIdToDelete(null);
        setDeleteTabEvent(null);

        // remove error data
        // const _error = [...err];
        err.splice(idToDelete, 1);
        setErr(items);
    };

    const handleDeleteDialogClickOpen = (event, index) => {
        event.stopPropagation();
        setIdToDelete(index);
        setDeleteTabEvent(event);
        setDeleteDialogOpen(true);
    };

    const handleDeleteDialogClose = () => {
        setDeleteDialogOpen(false);
        setIdToDelete(null);
        setDeleteTabEvent(null);
    };

    const handleDelete = async () => {
        try {
            const datum = formData[idToDelete];
            const id = datum?.action_standard_groups?.id;
            if (id) {
                const url = process.env.REACT_APP_SERVER_PATH + `/action-standard-groups/submit/${id}/`;
                await api
                    .delete(url)
                    .then((res) => {
                        console.log("result", res);
                    })
                    .catch((error) => {
                        handleError("error", error);
                    });
            }
            closeTab();
            handleDeleteDialogClose();
        } catch (error) {
            handleError("error", error);
        }
    };

    const handleResetData = (tab) => {
        // kpis.current.clearValue();
        // this block of code for reset formData
        const updatedFormData = formData.map((datum, i) => {
            if (i == tab) {
                if (studyType === "Fragrance Testing" || isBeautyAndWellbeing) {
                    return {
                        action_standard_groups: {
                            unileverProducts: unileverProducts,
                            competitorProducts: competitorProducts,
                        },
                        action_standard_kpis: [],
                    };
                } else {
                    return newFormData;
                }
            } else {
                return datum;
            }
        });
        setFormData([...updatedFormData]);
        formRef.current.reset();
        kpiRef.current.clearValue();
    };
    const handelExportData = async () => {
        try {
            const url = process.env.REACT_APP_SERVER_PATH + `/action-standard-groups/submit/export/`;

            const obj = formData[activeTab];
            const datum = {};
            Object.keys(obj.action_standard_groups.consumer_filter || {}).forEach((key) => {
                datum[key] = Array.isArray(obj.action_standard_groups.consumer_filter[key]) ? obj.action_standard_groups.consumer_filter[key].join(",") : obj.action_standard_groups.consumer_filter[key];
            });
            const kpis = isBeautyAndWellbeing  ? transformBwKpis(obj.action_standard_kpis) : obj.action_standard_kpis;

            const payload = {
                action_standard_groups: {
                    ...obj.action_standard_groups,
                    consumer_filter: datum,
                },
                action_standard_kpis: kpis,
            };

            const response = await api.post(url, payload, { responseType: "blob" });

            const blob = new Blob([response.data]);
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "action-standard-export.xlsx";
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error("Export failed", error);
        }
    };
    const isBtnDisabled = () => {
        let flag = false;
        formData.forEach((datum) => {
            if (datum?.action_standard_groups?.ul_product_sample_size === 0 || datum?.action_standard_groups?.comp_product_sample_size === 0) {
                flag = true;
            }
            if (isBeautyAndWellbeing) {
                const grp = datum?.action_standard_groups;
                if (!grp?.confidence_interval || !grp?.ul_product_code || !grp?.comp_product_code) {
                    flag = true;
                }
                const kpis = datum?.action_standard_kpis || [];
                const ifKpi = kpis.find((k) => k.is_if === true);
                const hasIfKpi = ifKpi?.kpi?.some((k) => k && String(k).trim() !== "");
                if (!hasIfKpi) {
                    flag = true;
                }
            }
        });

        return flag;
    };

    const isExportDisabled = () => {
        const grp = formData[activeTab]?.action_standard_groups;
        if (!grp?.confidence_interval || !grp?.ul_product_code || !grp?.comp_product_code) return true;
        const kpis = formData[activeTab]?.action_standard_kpis || [];
        const ifKpi = kpis.find((k) => k.is_if === true);
        return !ifKpi?.kpi?.some((k) => k && String(k).trim() !== "");
    };

    const validateForms = (formData) => {
        let errFlag = true;
        let errorMsg = [];
        formData.forEach((datum) => {
            let individualFormErrorMsg = {};
            const asForm = datum.action_standard_groups;
            const asKpi = datum.action_standard_kpis;
            if (asForm?.weight === undefined || asForm?.weight === null || asForm?.weight === "") {
                individualFormErrorMsg["weight"] = "Weight is required";
            }
            if (!asForm?.confidence_interval) {
                individualFormErrorMsg["confidence_interval"] = "Confidence Interval is required";
            }
            if (!asForm?.ul_product_code) {
                individualFormErrorMsg["ul_product_code"] = "Unilever Product is required";
            }
            if (!asForm?.comp_product_code) {
                individualFormErrorMsg["comp_product_code"] = "Benchmark Product is required";
            }
            const normalizeKpiItems = (kpiArray) => {
                return Array.isArray(kpiArray) ? kpiArray.filter(Boolean) : [];
            };

            const hasSelectedKpi = (kpiArray) => {
                return normalizeKpiItems(kpiArray).some((item) => {
                    if (!item) return false;
                    if (typeof item === "string") return item.trim() !== "";
                    if (typeof item === "object") return Boolean(item.backend_variable || item.value || item.backendVariable);
                    return false;
                });
            };

            const getKpiErrors = (entry) => {
                const errors = {};
                if (!hasSelectedKpi(entry?.kpi)) {
                    errors["kpi"] = "Kpi is required.";
                }
                if (entry?.min !== undefined && entry?.max !== undefined && parseInt(entry?.min) > parseInt(entry?.max)) {
                    errors["min"] = "At least is greater than out of.";
                }
                return errors;
            };

            if (asKpi.length) {
                if (asKpi.length === 1) {
                    if (!asKpi[0]?.is_if) {
                        individualFormErrorMsg = {
                            ...individualFormErrorMsg,
                            ifObj: {
                                kpi: "Kpi is required.",
                            },
                        };
                    } else {
                        const errors = getKpiErrors(asKpi[0]);
                        if (Object.keys(errors).length > 0) {
                            individualFormErrorMsg = {
                                ...individualFormErrorMsg,
                                ifObj: errors,
                            };
                        }
                    }
                } else if (asKpi.length > 1) {
                    asKpi.forEach((ele) => {
                        let obj = {};

                        if (ele.is_if === true) {
                            const ifObj = getKpiErrors(ele);
                            if (Object.keys(ifObj).length !== 0) {
                                obj = {
                                    ...obj,
                                    ifObj,
                                };
                            }
                        }
                        if (ele.is_if === false) {
                            const elseIfObj = getKpiErrors(ele);
                            if (Object.keys(elseIfObj).length !== 0) {
                                obj = {
                                    ...obj,
                                    elseIfObj,
                                };
                            }
                        }
                        individualFormErrorMsg = {
                            ...individualFormErrorMsg,
                            ...obj,
                        };
                    });
                }
            } else {
                const _elObj = asKpi.filter((ele) => ele.is_if === false)?.[0] || null;
                let obj = {
                    ifObj: {
                        kpi: "Kpi is required. else",
                    },
                };
                if (_elObj) {
                    obj = {
                        ...obj,
                        elseIfObj: {
                            kpi: "Kpi is required. else",
                        },
                    };
                }
                individualFormErrorMsg = {
                    ...individualFormErrorMsg,
                    ...obj,
                };
            }

            if (studyType === "Fragrance Testing" && !isHomeUseTest) {
                const getFragranceKpiErrors = (entry, isIfBlock = true) => {
                    const errors = {};
                    const kpiItems = Array.isArray(entry?.kpi) ? entry.kpi : [];

                    // Group level error when there are no KPI items
                    // if (!kpiItems.length) {
                    //     errors["kpi"] = "Kpi is required.";
                    // }

                    // Build per-item errors so UI can show row-level messages
                    const perItemErrors = kpiItems.map((item, itemIndex) => {
                        const currentItem = item || {};
                        const obj = {};
                        if (!currentItem?.backend_variable) obj.kpi = "Kpi is required.";
                        if (!currentItem?.test_name) obj.test_name = "Type of T-test is required.";

                        // For IF block: validate expected_result per KPI item
                        if (isIfBlock && !item?.expected_result) {
                            obj.expected_result = "Expected result is required.";
                        }

                        // For ELSE IF block: validate expected_result only on item 0
                        if (!isIfBlock && itemIndex === 0 && !item?.expected_result) {
                            obj.expected_result = "Expected result is required.";
                        }

                        // Operator validation
                        if (isIfBlock && kpiItems.length > 1 && itemIndex > 0 && !item?.opretor) {
                            obj.opretor = "Operator is required.";
                        }
                        // For else-if, operator is only on item 0 when multiple KPIs exist
                        if (!isIfBlock && kpiItems.length > 0 && itemIndex === 0 && !item?.opretor) {
                            obj.opretor = "Operator is required.";
                        }

                        return obj;
                    });

                    // If min/max are invalid, keep group-level min error
                    if (entry?.min !== undefined && entry?.max !== undefined && parseInt(entry?.min) > parseInt(entry?.max)) {
                        errors["min"] = "At least is greater than out of.";
                    }

                    const hasPerItemErrors = perItemErrors.some((it) => Object.keys(it).length > 0);
                    if (hasPerItemErrors) {
                        return {
                            ...errors,
                            items: perItemErrors,
                        };
                    }

                    return errors;
                };
                if (asKpi.length) {
                    if (asKpi.length === 1) {
                        if (!asKpi[0]?.is_if) {
                            individualFormErrorMsg = {
                                ...individualFormErrorMsg,
                                ifObj: {
                                    kpi: "Kpi is required.",
                                },
                            };
                        } else {
                            const errors = getFragranceKpiErrors(asKpi[0], true);
                            if (Object.keys(errors).length > 0) {
                                individualFormErrorMsg = {
                                    ...individualFormErrorMsg,
                                    ifObj: errors,
                                };
                            }
                        }
                    } else if (asKpi.length > 1) {
                        asKpi.forEach((ele) => {
                            let obj = {};

                            if (ele.is_if === true) {
                                const ifObj = getFragranceKpiErrors(ele, true);
                                if (Object.keys(ifObj).length !== 0) {
                                    obj = {
                                        ...obj,
                                        ifObj,
                                    };
                                }
                            }
                            if (ele.is_if === false) {
                                const elseIfObj = getFragranceKpiErrors(ele, false);
                                if (Object.keys(elseIfObj).length !== 0) {
                                    obj = {
                                        ...obj,
                                        elseIfObj,
                                    };
                                }
                            }
                            individualFormErrorMsg = {
                                ...individualFormErrorMsg,
                                ...obj,
                            };
                        });
                    }
                } else {
                    const errorItems = [{ kpi: "Kpi is required.", test_name: "Type of T-test is required.", expected_result: "Expected result is required." }];
                    individualFormErrorMsg = {
                        ...individualFormErrorMsg,
                        ifObj: {
                            items: errorItems,
                        },
                        // ELSE-IF is not mandatory, so skip validation here
                        // elseIfObj: {
                        //     items: errorItems,
                        // },
                    };
                }
            }
            if (Object.keys(individualFormErrorMsg).length > 0) {
                errFlag = false;
            }
            errorMsg.push(individualFormErrorMsg);
        });
        setErr(errorMsg);
        return errFlag;
    };

    return (
        <>
            {(isKpiOoDataMappingDataLoading || isASPostLoading || isASUpdateLoading) && <Loader />}
            <Box sx={{ borderBottom: 1, borderColor: "divider", marginBottom: 1 }}>
                <Tabs
                    value={activeTab}
                    onChange={handleTabChange}
                    aria-label="basic tabs example"
                    textColor="primary"
                    sx={{
                        height: 40,
                    }}
                >
                    {formData.map((ele, i) => {
                        const key = i + 1;
                        return (
                            <Tab
                                key={key}
                                icon={
                                    formData.length > 1 ? (
                                        <IconButton
                                            // onClick={(e) => closeTab(e,i)}
                                            onClick={(e) => handleDeleteDialogClickOpen(e, i)}
                                            aria-label="close"
                                            sx={{
                                                // position: "relative",
                                                // right: 0,
                                                color: "#ff0000b8 !important",
                                            }}
                                            style={{
                                                position: "absolute",
                                                top: "10px",
                                                right: "-5px",
                                            }}
                                        >
                                            <CancelIcon
                                                style={{
                                                    fontSize: 18,
                                                }}
                                            />
                                        </IconButton>
                                    ) : (
                                        ""
                                    )
                                }
                                iconPosition="end"
                                label={`AS-${i + 1}`}
                                {...a11yProps(0)}
                                sx={{
                                    margin: 0,
                                    padding: 0,
                                    height: "10px",
                                }}
                            />
                        );
                    })}
                    <div
                        style={{
                            minHeight: 40,
                        }}
                    >
                        <IconButton
                            onClick={addTab}
                            aria-label="add"
                            disabled={formData.length >= maxAllowedTabs || isAddTabDisabled}
                            sx={{
                                position: "relative",
                                top: 16,
                                // color:"rgb(51, 94, 234) !important" : "initial",
                            }}
                        >
                            <AddCircleRoundedIcon
                                style={{
                                    fontSize: 18,
                                }}
                            />
                        </IconButton>
                    </div>
                </Tabs>
            </Box>
            {formData.map((ele, i) => {
                const key = i + 1;
                return (
                    <CustomTabPanel
                        key={key}
                        value={activeTab}
                        index={i}
                    >
                        <div
                            style={{
                                padding: 20,
                            }}
                            className="liner-light-blue-background-2"
                        >
                            {studyType === "Fragrance Testing" && !isHomeUseTest ? (
                                <FragranceActionStandardForm
                                    key={`Acf${key}`}
                                    ref={formRef}
                                    tabId={i}
                                    formData={formData?.[i]?.action_standard_groups || {}}
                                    getAsFormData={getFragranceAsFormData}
                                    productSecondaryData={productSecondaryData}
                                    getAsCfData={getAsCfData}
                                    sampleInformation={sampleInformation}
                                    coreDataId={coreDataId}
                                    studyTypeMethod={studyTypeMethod}
                                    isWeighted={weighted}
                                    validation={err?.[activeTab] || {}}
                                    coreData={coreData}
                                />
                            ) : (
                                <ActionStandardForm
                                    key={`Acf${key}`}
                                    ref={formRef}
                                    tabId={i}
                                    formData={formData?.[i]?.action_standard_groups || {}}
                                    competitorProducts={competitorProducts}
                                    unileverProducts={unileverProducts}
                                    getAsFormData={isBeautyAndWellbeing ? getFragranceAsFormData : getAsFormData}
                                    productSecondaryData={productSecondaryData}
                                    getAsCfData={getAsCfData}
                                    sampleInformation={sampleInformation}
                                    coreDataId={coreDataId}
                                    studyTypeMethod={studyTypeMethod}
                                    isWeighted={weighted}
                                    validation={err?.[activeTab] || {}}
                                    coreData={coreData}
                                />
                            )}
                            {studyType === "Fragrance Testing" && !isHomeUseTest ? (
                                <FragranceActionStandardKPI
                                    key={`$AcK{i}`}
                                    ref={kpiRef}
                                    tabId={i}
                                    getAsKpiData={getAsKpiData}
                                    options={kpiOptions}
                                    formData={formData[i]?.action_standard_kpis || []}
                                    removeKpiCondition={removeKpiCondition}
                                    // error={err.length > 0 ? err[i] : {}}
                                    validation={err?.[activeTab] || {}}
                                    coreData={coreData}
                                    likertScaleData={likertScaleData}
                                />
                            ) : (
                                <ActionStandardKPI
                                    key={`$AcK{i}`}
                                    ref={kpiRef}
                                    tabId={i}
                                    getAsKpiData={getAsKpiData}
                                    options={kpiOptions}
                                    formData={formData[i]?.action_standard_kpis || []}
                                    removeKpiCondition={removeKpiCondition}
                                    // error={err.length > 0 ? err[i] : {}}
                                    validation={err?.[activeTab] || {}}
                                    isHomeUseTest={isHomeUseTest}
                                />
                            )}
                        </div>
                    </CustomTabPanel>
                );
            })}
            <Box
                className=""
                sx={{ width: "100%", textAlign: "center", paddingBottom: "5px" }}
            >
                <Button
                    size="small"
                    className={isBtnDisabled() ? "custom-btn custom-btn--upload-reset" : "custom-btn liner-light-blue-background custom-btn--upload-reset"}
                    variant="contained"
                    onClick={handleSubmit}
                    disabled={isBtnDisabled()}
                    style={{ display: viewOnly ? "none" : "inline-flex" }}
                >
                    Submit Action Standards
                </Button>
                {(isHairCare || isSkinCare) && (
                    <Button
                        size="small"
                        className={isExportDisabled() ? "custom-btn custom-btn--upload-reset" : "custom-btn liner-light-blue-background custom-btn--upload-reset"}
                        variant="contained"
                        onClick={handelExportData}
                        disabled={isExportDisabled()}
                    >
                        Export
                    </Button>
                )}

                {!Object.keys(formData[activeTab]?.action_standard_groups).includes("id") ? (
                    <Button
                        size="small"
                        className="custom-btn custom-btn--upload-reset"
                        variant="outlined"
                        onClick={() => handleResetData(activeTab)}
                    >
                        Reset
                    </Button>
                ) : (
                    ""
                )}
            </Box>
            <Dialog
                open={deleteDialogOpen}
                onClose={handleDeleteDialogClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle
                    sx={{
                        fontSize: 14,
                    }}
                    id="alert-dialog-title"
                >
                    Are you sure to remove the following group action standard data?
                </DialogTitle>
                <DialogContent>
                    <DialogContentText
                        sx={{
                            fontSize: 14,
                        }}
                        id="alert-dialog-description"
                    >
                        {formData?.[idToDelete]?.action_standard_groups.ul_product_code && formData?.[idToDelete]?.action_standard_groups.comp_product_code ? (
                            <>
                                Group: <span className="text-bold-6">{formData?.[idToDelete]?.action_standard_groups.ul_product_code}</span> and <span className="text-bold-6">{formData?.[idToDelete]?.action_standard_groups.comp_product_code}</span>
                            </>
                        ) : (
                            <></>
                        )}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        autoFocus
                        size="small"
                        className="custom-btn custom-btn--upload-reset"
                        variant="outlined"
                        onClick={handleDeleteDialogClose}
                    >
                        No
                    </Button>
                    <Button
                        size="small"
                        className="custom-btn custom-btn--upload-reset"
                        variant="outlined"
                        color="error"
                        onClick={handleDelete}
                    >
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

ActionStandardTabs.propTypes = {
    coreDataId: PropTypes.number,
    closeActionStandardModal: PropTypes.func,
    studyTypeMethod: PropTypes.number,
    weighted: PropTypes.bool,
    coreData: PropTypes.object,
    viewOnly: PropTypes.bool,
    // setIsASUpdateLoading: PropTypes.func,
    // setIsASPostLoading: PropTypes.func,
};

export default ActionStandardTabs;
